import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import imagen from "../../assets/Home/Recurso 7.png";

const BrandLeyenda = () => {
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Container sx={{
      width: "100%",
      display: "grid !important",
      placeItems: "center",
    }}>
      <Box
        display="flex"
        mt="50px"
        flexDirection={isMobile ? "column" : "row"}
        justifyContent="center"
        margin= "20px 0px"
      >
        <Box
          display="grid"
          alignContent="center"
          align="center"
          color="#18246B"
          height="inherit"
          sx={{
            width: "100%",
            padding: "0 18px",
            mb:{xs:"16px", md:"0"}
          }}
        >
          <Typography variant={isMobile ? "h4" : "h2"} fontWeight={700} marginBottom={"8px"}>
            Somos más que un hospital
          </Typography>
          <Typography variant="h5" textAlign="justify">
            Con experiencia de más de 32 años, somos especialistas en brindar un
            trato humano, con la calidez y calidad que cada uno de nuestros
            pacientes necesita, ayudándoles en la recuperación de su bienestar.
          </Typography>
        </Box>
        <Box
          component="img"
          src={imagen}
          alt="Banner"
          loading="lazy"
          alignSelf="center"
          sx={{
            width: "100%",
            maxWidth: "400px",
            objectFit: "fill",
            ml: {xs:"0px", sm:"36px"}
          }}
        />
      </Box>
    </Container>
  );
};

export default BrandLeyenda;
